<div class="flex flex-col flex-1 overflow-hidden">
    <div class="grid-header">

        <!-- FILTER DIALOG -->
        <button
            mat-icon-button
            (click)="toggleFilter()"
            class="mr-2"
        >
            <mat-icon [matBadge]="activeFilters.length" [matBadgeHidden]="activeFilters.length == 0" matBadgeColor="warn">filter_list</mat-icon>
            <span class="cdk-visually-hidden">
                Filter icon showing active filters with a value of {{activeFilters.length}}
              </span>
        </button>

        <!-- COLUMNS CONFIGURATOR -->
        <button
            mat-icon-button
            (click)="handleColumnsDialog()"
            class="mr-2"
        >
            <mat-icon class="icon-size-6">table_chart</mat-icon>
        </button>
    </div>
    <div class="overflow-auto">
        <table mat-table [dataSource]="data?.rows" matSort class="w-full flex-1">
            <ng-container *ngFor="let columnConfig of columnsConfig">

                <ng-container   [matColumnDef]="columnConfig.field"
                                [sticky]="columnConfig.sticky">

                    <!-- ngSwitch for grid cell -->
                    <ng-container [ngSwitch]="columnConfig.type" *ngIf="!columnConfig.hidden">

                        <!-- STRING -->
                        <ng-container *ngSwitchCase="columnConfigType.STRING">
                            <th mat-header-cell
                                *matHeaderCellDef
                                [disabled]="!columnConfig.sort"
                                [ngClass]="columnConfig.headerClass"
                                [mat-sort-header]="columnConfig.sort">
                                {{
                                    columnConfig.translation ?
                                    translations[columnConfig.translation.toPascalCase()] :
                                    translations[columnConfig.field.toPascalCase()]
                                }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element | get:columnConfig.field }}
                            </td>
                        </ng-container>

                        <!-- TRANSLATIONS_MENU -->
                        <ng-container *ngSwitchCase="columnConfigType.TRANSLATIONS_MENU">
                            <th mat-header-cell
                                *matHeaderCellDef
                                [disabled]="!columnConfig.sort"
                                [ngClass]="columnConfig.headerClass"
                                [mat-sort-header]="columnConfig.sort">
                                {{
                                    columnConfig.translation ?
                                    translations[columnConfig.translation.toPascalCase()] :
                                    translations[columnConfig.field.toPascalCase()]
                                }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <au-translations-menu   [langs]="langs"
                                                        [moduleUri]="moduleUri"
                                                        [row]="element">
                                </au-translations-menu>
                            </td>
                        </ng-container>

                        <!-- ACTIONS -->
                        <ng-container *ngSwitchCase="columnConfigType.ACTIONS">
                            <th mat-header-cell
                                *matHeaderCellDef
                                [disabled]="!columnConfig.sort"
                                [ngClass]="columnConfig.headerClass"
                                [mat-sort-header]="columnConfig.sort">
                                {{
                                    columnConfig.translation ?
                                    translations[columnConfig.translation.toPascalCase()] :
                                    translations[columnConfig.field.toPascalCase()]
                                }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button [matMenuTriggerFor]="menu" class="ml-7">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <ng-container *ngFor="let action of columnConfig.actions | getActions:element">
                                        <button mat-menu-item (click)="handleClickAction(action, element, $event)">
                                            <mat-icon>{{ action.icon }}</mat-icon>
                                            <span>{{ translations[action.translation] }}</span>
                                        </button>
                                    </ng-container>
                                </mat-menu>
                            </td>
                        </ng-container>

                    </ng-container>
                    <!-- / ngSwitch for grid cell -->

                </ng-container>

            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
    </div>

    <mat-paginator  [length]="data.count"
                    [pageSizeOptions]="[10, 20, 50, 100]"
                    showFirstLastButtons
                    class="rounded-b-md"
                    aria-label="Select page of periodic elements">
    </mat-paginator>
</div>
